// extracted by mini-css-extract-plugin
export default {"root":"Step-root-97b60f138d36d2c3c68de86b41cf82b0","text":"Step-text-2b9e02d5a1e21eafb417e94c3de74e8d"};